import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { updateCompanyPrice } from "../api/updateCompanyPrice";

export const useUpdateCompanyPrice = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, body }) => updateCompanyPrice(companyId, body),
    onSuccess: () => {
      toast.success("Company price updated successfully!");
      queryClient.invalidateQueries({ queryKey: ["subscriptionDetails"] });
      queryClient.invalidateQueries({ queryKey: ["allSubscriptions"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to update company price.");
    },
  });
};

